import { render, staticRenderFns } from "./ModalModulosPrograma.vue?vue&type=template&id=4848ff10"
import script from "./ModalModulosPrograma.vue?vue&type=script&lang=js"
export * from "./ModalModulosPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports